import React, { useRef, useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu } from "antd";

export default function CoachHeader({ cohortInfo }) {

  

  // console.log(cohortInfo,"im new cohorInfo")
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);


  const updateScrollButtons = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
    }
  };


  const menu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          // localStorage.removeItem("token");
          // localStorage.removeItem("isCoach");
          localStorage.clear();
          window.location.href = "/signin";
        }}
      >
        Log Out
      </Menu.Item>
    </Menu>
  );



  const scroll = (direction) => {
    if (!scrollContainerRef.current) return;
  
    const scrollAmount = 8000; // Total pixels to scroll
    const duration = 1; // Total time in milliseconds (2 seconds)
    const intervalTime = 150; // Small steps every 10ms for smooth effect
    const step = (scrollAmount / (duration / intervalTime)); // Small increment per step
  
    let currentScroll = scrollContainerRef.current.scrollLeft;
    const targetScroll = currentScroll + (direction === "left" ? -scrollAmount : scrollAmount);
  
    const smoothScroll = setInterval(() => {
      if ((direction === "left" && currentScroll <= targetScroll) ||
          (direction === "right" && currentScroll >= targetScroll)) {
        clearInterval(smoothScroll);
        return;
      }
  
      currentScroll += (direction === "left" ? -step : step);
      scrollContainerRef.current.scrollLeft = currentScroll;
    }, intervalTime);
  };
  

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      updateScrollButtons();
      container.addEventListener('scroll', updateScrollButtons);
      return () => container.removeEventListener('scroll', updateScrollButtons);
    }
  }, []);

  useEffect(() => {
    console.log("Component mounted!");
  }, []);

  // if (!cohortInfo || Object.keys(cohortInfo).length === 0) {
  //   return <div>Loading cohort information...</div>;
  // }

  const convertTotalTimeSpent = (seconds) => {
    const monthInSeconds = 2592000; // 60 * 60 * 24 * 30
    const weekInSeconds = 604800; // 60 * 60 * 24 * 7
    const dayInSeconds = 86400; // 60 * 60 * 24
    const hourInSeconds = 3600; // 60 * 60
    const minuteInSeconds = 60;
    
    let value;
    let unit;
    
    if (seconds >= monthInSeconds) {
        value = (seconds / monthInSeconds).toFixed(2);
        unit = "months";
    } else if (seconds >= weekInSeconds) {
        value = (seconds / weekInSeconds).toFixed(2);
        unit = "weeks";
    } else if (seconds >= dayInSeconds) {
        value = (seconds / dayInSeconds).toFixed(2);
        unit = "days";
    } else if (seconds >= hourInSeconds) {
        value = (seconds / hourInSeconds).toFixed(2);
        unit = "hours";
    } else if (seconds >= minuteInSeconds) {
        value = (seconds / minuteInSeconds).toFixed(2);
        unit = "minutes";
    } else {
        value = seconds.toFixed(2);
        unit = "seconds";
    }
    
    return `${value} ${unit}`;
  };

  return (
    <>
      <div className="coach-dashboard">
        <header className="header-coach-dashboard">
          <div className="header-inner-left">
            <Link to={`/coach/dashboard/`}>
              <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/logo.png" width="123.95px" height="32px" />
            </Link>
            <span className='user-name-header-top'>Welcome, Rachel</span>
              <Link to={`/coach/dashboard/`}>
                <p className="coach-dashboard-text">Coach Dashboard</p>
              </Link>
          </div>
          <Dropdown overlay={menu} placement="bottomLeft">
            <Button type="text" style={{ color: "white" }}>
              <span className='right-container-user-name'>Rachel Serwetz</span><DownOutlined />
            </Button>
          </Dropdown>
        </header>
      </div>
      
      <div className="metrics-container">
        {canScrollLeft && (
          <button
            className="scroll-button scroll-left"
            onClick={() => scroll('left')}
            aria-label="Scroll left"
          >
            <svg width="66" height="67" viewBox="0 0 66 67" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_39642_22788)">
                <circle cx="33" cy="30.5" r="17" fill="white"/>
              </g>
              <path d="M36.75 38.5L29.25 31L36.75 23.5" stroke="#199094" strokeWidth="2"/>
              <defs>
                <filter id="filter0_d_39642_22788" x="0" y="0.5" width="66" height="66" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                  <feOffset dy="3"/>
                  <feGaussianBlur stdDeviation="8"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0.0745098 0 0 0 0 0.0745098 0 0 0 0 0.0745098 0 0 0 0.1 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_39642_22788"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_39642_22788" result="shape"/>
                </filter>
              </defs>
            </svg>
          </button>
        )}

        <div className="metrics-scroll" ref={scrollContainerRef}>
          {/* Metrics content */}
          <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Total Number Of Users</span></div>
              <div className='mertic-bottom-container'>
              <span className='metric-subtitle'>{cohortInfo.total_users ? cohortInfo.total_users + " users" : (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span>
              </div>
          </div>
          <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Total Active Users</span></div>
              <div className='mertic-bottom-container'>
              <span className='metric-subtitle'>{cohortInfo.total_active_users ? cohortInfo.total_active_users + " users" : (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span>
              </div>
          </div>
          <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Average Retention</span></div>
              <div className='mertic-bottom-container'>
              {/* <span className='metric-subtitle'>{cohortInfo.total_time_spent ? convertTotalTimeSpent(cohortInfo.total_time_spent) : (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span> */}
              <span className='metric-subtitle'>{cohortInfo.months_on_platform ? (cohortInfo.months_on_platform ?? 0).toFixed(2) + " months" : (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span>
              </div>
          </div>
          {/* <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Days Since Last Session</span></div>
              <div className='mertic-bottom-container'>
              <span className='metric-subtitle'>{cohortInfo.days_since_last_session?.toFixed(2)}</span>
              </div>
          </div> */}
          {/* <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Months on Platform</span></div>
              <div className='mertic-bottom-container'>
              <span className='metric-subtitle'>{cohortInfo.months_on_platform ? (cohortInfo.months_on_platform ?? 0).toFixed(2) : (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span>
              </div>
          </div> */}
          <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Average Time Spent On Platform (Per Week)</span></div>
              <div className='mertic-bottom-container'>
              <span className='metric-subtitle'>{cohortInfo.time_spent_per_week || (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span>
              </div>
          </div>
          <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Average Sessions Per Client (Per Month)</span></div>
              <div className='mertic-bottom-container'>
              <span className='metric-subtitle'>{cohortInfo.sessions_per_month ? (cohortInfo.sessions_per_month ?? 0).toFixed(2) + " sessions" : (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span>
              </div>
          </div>
          <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Average Session Length</span></div>
              <div className='mertic-bottom-container'>
              <span className='metric-subtitle'>{cohortInfo.session_length_time || (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span>
              </div>
          </div>
          <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Average Level of Stress</span></div>
              <div className='mertic-bottom-container'>
              <span className='metric-subtitle'>{cohortInfo.stress_level ? (cohortInfo.stress_level ?? 0).toFixed(2) + "/10" : (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span>
              </div>
          </div>
          <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Level Of Certainty On Process</span></div>
              <div className='mertic-bottom-container'>
              <span className='metric-subtitle'>{cohortInfo.confidence_level ? (cohortInfo.confidence_level ?? 0).toFixed(2) + "/10" : (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span>
              </div>
          </div>
          <div className="metric-card">
            <div className="mertic-top-container">
              <span className='metric-title'>Level Of Career Clarity</span></div>
              <div className='mertic-bottom-container'>
              <span className='metric-subtitle'>{cohortInfo.clarity_level ? (cohortInfo.clarity_level ?? 0).toFixed(2) + "/10" : (<LoadingOutlined style={{ fontSize: 30, color: "#199094" }} />)}</span>
              </div>
          </div>
        </div>

        {canScrollRight && (
          <button
            className="scroll-button scroll-right"
            onClick={() => scroll('right')}
            aria-label="Scroll right"
          >
           <svg width="66" height="67" viewBox="0 0 66 67" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_39642_22788)">
                <circle cx="33" cy="30.5" r="17" fill="white"/>
              </g>
              <path d="M29.25 23.5L36.75 31L29.25 38.5" stroke="#199094" strokeWidth="2"/>
              <defs>
                <filter id="filter0_d_39642_22788" x="0" y="0.5" width="66" height="66" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                  <feOffset dy="3"/>
                  <feGaussianBlur stdDeviation="8"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0.0745098 0 0 0 0 0.0745098 0 0 0 0 0.0745098 0 0 0 0.1 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_39642_22788"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_39642_22788" result="shape"/>
                </filter>
              </defs>
            </svg>
          </button>
        )}
      </div>
    </>
  );
}

{/* <div className="name-header">welcome, Rachel!</div>
          <Row>
            {/* <Col span={10}></Col> */}
          //   <Col span={24}>
          //     {this.state.cohortInfo ? (
          //       this.state.cohortInfo.total_active_users ? (
          //         <p
          //           style={{
          //             font: "normal normal 600 14px/7px AvenirBook",
          //             padding: "10px 0 0 40px",
          //             color: "#51e34c",
          //             textAlign: "left",
          //           }}
          //         >
          //           Cohort &nbsp;&nbsp;&nbsp;
          //           <span className="active-users">
          //             {this.state.cohortInfo.total_active_users
          //               ? this.state.cohortInfo.total_active_users
          //               : ""}{" "}
          //             Users
          //           </span>
          //         </p>
          //       ) : (
          //         ""
          //       )
          //     ) : (
          //       ""
          //     )}
          //     <div className="cohort-box">
          //       <div className="avg-time">
          //         Days since last use
          //         <div
          //           style={{
          //             font: "normal normal bold 11px/25px AvenirBook",
          //             color: "#000000",
          //           }}
          //         >
          //           {Object.keys(this.state.cohortInfo).length > 0
          //             ? this.state.cohortInfo.days_since_last_session.toFixed(2)
          //             : ""}
          //         </div>
          //       </div>
          //       <div className="avg-time">
          //         Months
          //         <div
          //           style={{
          //             font: "normal normal bold 11px/25px AvenirBook",
          //             color: "#000000",
          //           }}
          //         >
          //           {Object.keys(this.state.cohortInfo).length > 0
          //             ? this.state.cohortInfo.months_on_platform.toFixed(2)
          //             : ""}
          //         </div>
          //       </div>
          //       <div className="avg-time">
          //         Weekly time
          //         <div
          //           style={{
          //             font: "normal normal bold 11px/25px AvenirBook",
          //             color: "#000000",
          //           }}
          //         >
          //           {Object.keys(this.state.cohortInfo).length > 0
          //             ? this.state.cohortInfo.time_spent_per_week
          //             : ""}
          //         </div>
          //       </div>
          //       <div className="avg-time">
          //         Sessions per month
          //         <div
          //           style={{
          //             font: "normal normal bold 11px/25px AvenirBook",
          //             color: "#000000",
          //           }}
          //         >
          //           {Object.keys(this.state.cohortInfo).length > 0
          //             ? this.state.cohortInfo.sessions_per_month.toFixed(2)
          //             : ""}
          //         </div>
          //       </div>
          //       <div className="avg-time">
          //         Session length time
          //         <div
          //           style={{
          //             font: "normal normal bold 11px/25px AvenirBook",
          //             color: "#000000",
          //           }}
          //         >
          //           {Object.keys(this.state.cohortInfo).length > 0
          //             ? this.state.cohortInfo.session_length_time
          //             : ""}
          //         </div>
          //       </div>
          //       <div className="avg-time">
          //         Overall time
          //         <div
          //           style={{
          //             font: "normal normal bold 11px/25px AvenirBook",
          //             color: "#000000",
          //           }}
          //         >
          //           {Object.keys(this.state.cohortInfo).length > 0
          //             ? this.state.cohortInfo.total_time_spent
          //             : ""}
          //         </div>
          //       </div>
          //       <div className="avg-time">
          //         Level of stress
          //         <div
          //           style={{
          //             font: "normal normal bold 11px/25px AvenirBook",
          //             color: "#000000",
          //           }}
          //         >
          //           {Object.keys(this.state.cohortInfo).length > 0
          //             ? this.state.cohortInfo.stress_level.toFixed(2)
          //             : ""}
          //         </div>
          //       </div>
          //       <div className="avg-time">
          //         Level of career clarity
          //         <div
          //           style={{
          //             font: "normal normal bold 11px/25px AvenirBook",
          //             color: "#000000",
          //           }}
          //         >
          //           {Object.keys(this.state.cohortInfo).length > 0
          //             ? this.state.cohortInfo.clarity_level.toFixed(2)
          //             : ""}
          //         </div>
          //       </div>
          //       <div className="avg-time">
          //         Level of certainty on process
          //         <div
          //           style={{
          //             font: "normal normal bold 11px/25px AvenirBook",
          //             color: "#000000",
          //           }}
          //         >
          //           {Object.keys(this.state.cohortInfo).length > 0
          //             ? this.state.cohortInfo.confidence_level.toFixed(2)
          //             : ""}
          //         </div>
          //       </div>
          //     </div>
          //   </Col>
          // </Row>
        // </div> 


